// Open external links in new tabs
document.addEventListener('DOMContentLoaded', () => {
  if (navigator.userAgent.includes('app_ua')) {
    const sectionHeader = document.getElementById('shopify-section-header')
    const sectionAnouncement = document.getElementById('shopify-section-announcement-bar');
    const sectionPromotion = document.getElementById('shopify-section-promos-banner');

    if(sectionHeader) {
      sectionHeader.classList.add('hidden');
    }

    if(sectionAnouncement) {
      sectionAnouncement.classList.add('hidden');
    }

    if(sectionPromotion) {
      sectionPromotion.classList.add('hidden');
    }

    const footers = document.querySelectorAll('footer');
    footers.forEach(footer => {
        footer.classList.add('hidden');
    });
  }
});

var links = document.links;
for (let i = 0; i < links.length ; i++) {
  var linkHostName = links[i].hostname;
  if (linkHostName && linkHostName !== window.location.hostname) {
    links[i].target = '_blank';
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input'); 
    this.input.addEventListener('change', this.onChange.bind(this))
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  
  onChange() {
    if (Number(this.input.value) < 1 ) {
      this.input.value = "1";
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.header = document.querySelector('#shopify-section-header');
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.announcementBar.classList.add('hide-header')
    this.header.classList.add('hide-header')
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.announcementBar.classList.remove('hide-header')
    this.header.classList.remove('hide-header')
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class SizeChartTable extends HTMLElement {
  constructor() {
    super();

    this.tableContainers = document.querySelectorAll('#tableContainer');

    if (!this.tableContainers) return;

    const unitToggle = document.getElementById('switch_units');

    this.tableContainers.forEach((container, index) => {
      const UNIT_DELIMITER = '|';
      const tableFileUrl = container.dataset.tableCsv;
      const tableUnitConversion = container.dataset.unitConversion;
      const sizeChartTable = container.querySelector('#sizeChartTable');

      if (!tableFileUrl) return;
      
      Papa.parse(tableFileUrl, {
        download: true,
        skipEmptyLines: true,
        complete: function(results) {  
          const jsonData = results.data;
          displayTable(jsonData);
        }
      });

      function displayTable(data) {
        if (data.length === 0) {
          sizeChartTable.innerHTML = '<p>No data found in CSV.</p>';
          return;
        }
  
        // Create table
        const table = document.createElement('table');
  
        // Create header row
        const headerRow = document.createElement('tr');
  
        Object.keys(data[0]).forEach(key => {
          const th = document.createElement('th');
  
          th.textContent = data[0][key];
          headerRow.appendChild(th);
        });
  
        table.appendChild(headerRow);
  
        // Create data rows
        data.forEach((row, index) => {
          if (index > 0) {
            const tr = document.createElement('tr');
            
            Object.values(row).forEach(value => {
              const td = document.createElement('td');
  
              // check if unitconversion is turned on
              // split the value by |
              // wrap second value in span, add class, and hide
              if (tableUnitConversion) {
                if (value.includes(UNIT_DELIMITER)) {
                  const valueArray = value.split(UNIT_DELIMITER);
  
                  td.dataset.toggleUnits = true;
  
                  value = `<span data-unit-1>${valueArray[0]}</span><span data-unit-2 style="display:none;">${valueArray[1]}</span>`;
                }
              }
              td.innerHTML = value;
              tr.appendChild(td);
            });
  
            table.appendChild(tr);
          }
        });
  
        sizeChartTable.innerHTML = ''; // Clear previous table
        sizeChartTable.appendChild(table); // Append new table
      };
    });

    if (unitToggle) {
      unitToggle.addEventListener("change", () => {
        toggleUnits();
      });
    }
    
    function toggleUnits() {
      const cellsToConvert = document.querySelectorAll('[data-toggle-units]');

      if (unitToggle.checked) {
        cellsToConvert.forEach(cell => {
          cell.querySelector('[data-unit-2]').style.display = "block";
          cell.querySelector('[data-unit-1]').style.display = "none";
        });
      } else {
        cellsToConvert.forEach(cell => {
          cell.querySelector('[data-unit-1]').style.display = "block";
          cell.querySelector('[data-unit-2]').style.display = "none";
        });
      }
    }
  }
}
customElements.define("size-chart-table", SizeChartTable);

class DrawerModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[data-drawer-modal-trigger]');

    if (!button) return;

    button.addEventListener('click', (event) => {
      const modalID = event.target.getAttribute('data-drawer-modal');
      const modal = document.querySelector(modalID);

      // check button for data-modal-content-url
      // use URL in Sections API request for size charts

      if (modal) {
        event.preventDefault();

        if(event.target.dataset.modalContentUrl) {
          const modalContentUrl = event.target.dataset.modalContentUrl;
          const modalContentContainers = [document.getElementById('SizeChartContent'), modal.querySelector('#CustomCTAContent')];
        
          async function fetchPageData(handle, containers) {
            const url = `${window.Shopify.routes.root}${handle}`;
            console.log("🌐 Fetching URL:", url);
      
            try {
              const res = await fetch(url);
              const html = await res.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");

              const modalContent = doc.querySelector('#MainContent');
            
              if(modalContent) {
                containers.forEach(function(container, index){
                  if(container) {
                    container.innerHTML = modalContent.outerHTML;
                  }  
                });
                
                //show modal
                modal.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
      
            } catch (err) {
              console.error("🚨 Error during fetchPageData:", err);
              container.innerHTML = "<p>Error loading page info.</p>";

              modal.classList.add('active');
            }
          }

          fetchPageData(modalContentUrl, modalContentContainers);
        } else if(event.target.dataset.drawerModalIframe) {
          const iframe = document.getElementById('iFrameContent');

          iframe.src = event.target.href;

          modal.classList.add('active');
          document.body.classList.add('overflow-hidden');
        } else {
          modal.classList.add('active');
          document.body.classList.add('overflow-hidden');
        }
      } 
    });
  }
}
customElements.define('drawer-modal-opener', DrawerModalOpener);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.slideSelectorParent = this.querySelector('.slide-selectors');
    this.slideSelectors = this.querySelectorAll('.slide-selector');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.initSlideSelectors();

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initSlideSelectors() {
    if(!this.slideSelectors.length) return;

    for( let slideSelector of this.slideSelectors ) {
      slideSelector.addEventListener('click', this.slideSelectorClick.bind(this))
    }
  }

  slideSelectorClick(event) {
    let slideToNavigate = event.target.dataset.slide;
    const axis = this.getScrollAxis();
    const itemSize = axis === 'vertical'
      ? this.sliderLastItem.clientHeight
      : this.sliderLastItem.clientWidth;
    const slideScrollPosition = slideToNavigate * itemSize;
    if (axis === 'vertical') {
      this.slider.scrollTo({ top: slideScrollPosition, behavior: 'smooth' });
    } else {
      this.slider.scrollTo({ left: slideScrollPosition, behavior: 'smooth' });
    }
    this.setActiveSelector(slideToNavigate)
  }

  setActiveSelector(slideIndex) {
    if(typeof slideIndex == 'undefined') slideIndex = 0;

    for( let slideSelector of this.slideSelectors ) {
      slideSelector.classList.remove('active')
    }

    this.slideSelectors[slideIndex].classList.add('active')
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) {
      this.updateScrollState();
      return;
    }
    const axis = this.getScrollAxis();
    const viewportSize = axis === 'vertical' ? this.slider.clientHeight : this.slider.clientWidth;
    const itemSize = axis === 'vertical'
      ? this.sliderItemsToShow[0].clientHeight
      : this.sliderItemsToShow[0].clientWidth;
    if (!itemSize) {
      this.updateScrollState();
      return;
    }
    this.slidesPerPage = Math.floor(viewportSize / itemSize);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.sliderLastItem) {
      this.updateScrollState();
      return;
    }

    const previousPage = this.currentPage;
    const axis = this.getScrollAxis();
    if (axis === 'vertical') {
      const step = this.sliderLastItem.clientHeight || 1;
      this.currentPage = Math.round(this.slider.scrollTop / step) + 1;
    } else {
      const step = this.sliderLastItem.clientWidth || 1;
      this.currentPage = Math.round(this.slider.scrollLeft / step) + 1;
    }
    this.updateScrollState();

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.slideSelectors.length) {
      this.setActiveSelector(this.currentPage - 1);
    } 

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  getScrollAxis() {
    const horizontalOverflow = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
    const verticalOverflow = Math.max(0, this.slider.scrollHeight - this.slider.clientHeight);

    return verticalOverflow > horizontalOverflow ? 'vertical' : 'horizontal';
  }

  updateScrollState() {
    if (!this.slider) return;

    const axis = this.getScrollAxis();
    const scrollPosition = axis === 'vertical' ? this.slider.scrollTop : this.slider.scrollLeft;
    const scrollSize = axis === 'vertical' ? this.slider.scrollHeight : this.slider.scrollWidth;
    const clientSize = axis === 'vertical' ? this.slider.clientHeight : this.slider.clientWidth;
    const maxScroll = Math.max(0, scrollSize - clientSize);
    const isThumbnailRail = this.id && this.id.indexOf('GalleryThumbnails') === 0;
    const sliderStyle = window.getComputedStyle(this.slider);
    const startInset = axis === 'vertical'
      ? parseFloat(sliderStyle.paddingTop || '0')
      : parseFloat(sliderStyle.paddingLeft || '0');
    const endInset = axis === 'vertical'
      ? parseFloat(sliderStyle.paddingBottom || '0')
      : parseFloat(sliderStyle.paddingRight || '0');
    const baseTolerance = isThumbnailRail ? 8 : 1;
    const startTolerance = baseTolerance + (isThumbnailRail ? startInset : 0);
    const endTolerance = baseTolerance + (isThumbnailRail ? endInset : 0);
    const overflowTolerance = Math.max(startTolerance, endTolerance);

    this.dataset.scrollAxis = axis;
    this.classList.toggle('is-overflowing', maxScroll > overflowTolerance);
    this.classList.toggle('is-at-start', scrollPosition <= startTolerance);
    this.classList.toggle('is-at-end', scrollPosition >= maxScroll - endTolerance);
  }

  isSlideVisible(element, offset = 0) {
    if (!this.slider) return false;
    const axis = this.getScrollAxis();
    if (axis === 'vertical') {
      const lastVisible = this.slider.clientHeight + this.slider.scrollTop - offset;
      return (
        element.offsetTop + element.clientHeight <= lastVisible &&
        element.offsetTop >= this.slider.scrollTop + offset
      );
    }
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft + offset
    );
  }

  /**
   * Scrolls a slide/thumbnail into view inside this slider's scroll container (Horizon-style),
   * supporting both horizontal and vertical overflow axes.
   */
  scrollItemIntoView(item, { behavior = 'smooth', block = 'center', inline = 'center' } = {}) {
    if (!this.slider || !item) return;

    const ancestor = this.slider;
    const elemRect = item.getBoundingClientRect();
    const ancestorRect = ancestor.getBoundingClientRect();

    const calculateScrollOffset = (alignment, ancestorStart, ancestorLength, elemStart, elemLength, currentScroll) => {
      switch (alignment) {
        case 'start':
          return currentScroll + elemStart - ancestorStart;
        case 'center':
          return currentScroll + elemStart - ancestorStart - ancestorLength / 2 + elemLength / 2;
        case 'end':
          return currentScroll + elemStart - ancestorStart - ancestorLength + elemLength;
        default:
          return currentScroll;
      }
    };

    let scrollTop = ancestor.scrollTop;
    if (ancestor.scrollHeight > ancestor.clientHeight) {
      scrollTop = calculateScrollOffset(
        block,
        ancestorRect.top,
        ancestor.clientHeight,
        elemRect.top,
        elemRect.height,
        ancestor.scrollTop
      );
    }

    let scrollLeft = ancestor.scrollLeft;
    if (ancestor.scrollWidth > ancestor.clientWidth) {
      scrollLeft = calculateScrollOffset(
        inline,
        ancestorRect.left,
        ancestor.clientWidth,
        elemRect.left,
        elemRect.width,
        ancestor.scrollLeft
      );
    }

    const maxTop = Math.max(0, ancestor.scrollHeight - ancestor.clientHeight);
    const maxLeft = Math.max(0, ancestor.scrollWidth - ancestor.clientWidth);

    ancestor.scrollTo({
      top: Math.max(0, Math.min(scrollTop, maxTop)),
      left: Math.max(0, Math.min(scrollLeft, maxLeft)),
      behavior,
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = parseInt(event.currentTarget.dataset.step || '1', 10);
    const axis = this.getScrollAxis();
    const itemSize = this.sliderLastItem
      ? axis === 'vertical'
        ? this.sliderLastItem.clientHeight
        : this.sliderLastItem.clientWidth
      : 0;
    const delta = step * itemSize;

    if (axis === 'vertical') {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + delta
          : this.slider.scrollTop - delta;
      this.slider.scrollTo({ top: this.slideScrollPosition });
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + delta
          : this.slider.scrollLeft - delta;
      this.slider.scrollTo({ left: this.slideScrollPosition });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class PDPSliderComponent extends SliderComponent {
  constructor() {
    super();

    this.gallery = this.closest('media-gallery');
    this.mediaQueryMobile = window.matchMedia('(max-width: 749px)');
    this.handleViewportChange = this.applyGalleryBehavior.bind(this);
    this.handleWindowResize = this.syncThumbnailRailHeight.bind(this);

    this.sortableSlides = Array.from(this.querySelectorAll('li.product__media-item'));
    this.thumbnailSlider = this.gallery ? this.gallery.querySelector('[id^="Slider-Thumbnails"]') : null;
    this.sortableThumbnailItems = this.thumbnailSlider
      ? Array.from(this.thumbnailSlider.querySelectorAll('.thumbnail-list__item'))
      : [];

    this.sortSlides();
    this.sortThumbnailItems();
    this.resetPages();
    this.updateFirstVisibleMediaItem();
    this.initVariantChangeListener();
    this.applyGalleryBehavior();
    this.initGalleryResizeObserver();
    this.mediaQueryMobile.addEventListener('change', this.handleViewportChange);
    window.addEventListener('resize', this.handleWindowResize);
  }

  compareMediaOrder(a, b) {
    const optionCompare = a.dataset.option1.localeCompare(b.dataset.option1, undefined, {
      numeric: true,
      sensitivity: 'base'
    });

    if (optionCompare !== 0) return optionCompare;

    return a.dataset.imageIndex.localeCompare(b.dataset.imageIndex, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  getMediaItemForThumbnail(thumbnailItem) {
    if (!this.gallery || !thumbnailItem?.dataset.target) return null;

    return this.gallery.querySelector(`[data-media-id="${thumbnailItem.dataset.target}"]`);
  }

  isImageMediaElement(element) {
    const mediaItem = element.classList.contains('product__media-item')
      ? element
      : this.getMediaItemForThumbnail(element);

    return mediaItem?.dataset.mediaType === 'image';
  }

  sortElementsByMediaOrder(elements, target, { imagesFirst = false } = {}) {
    if (!elements.length || !target) return;

    const sortableElements = imagesFirst
      ? [
        ...elements
          .filter((element) => this.isImageMediaElement(element) && element.dataset.option1 && element.dataset.imageIndex)
          .sort(this.compareMediaOrder),
        ...elements.filter((element) => this.isImageMediaElement(element) && (!element.dataset.option1 || !element.dataset.imageIndex)),
        ...elements.filter((element) => !this.isImageMediaElement(element)),
      ]
      : [...elements].sort(this.compareMediaOrder);

    sortableElements.forEach((element) => {
      target.appendChild(element);
    });
  }

  sortSlides() {
    if (this.slider) {
      this.sortElementsByMediaOrder(this.sortableSlides, this.slider, { imagesFirst: true });
    }
  }

  sortThumbnailItems() {
    this.sortElementsByMediaOrder(this.sortableThumbnailItems, this.thumbnailSlider, { imagesFirst: true });
  }

  triggerVariantSelect() {
    const variantRadio = document.querySelector('variant-radios')
    if (variantRadio) variantRadio.dispatchEvent(new Event('change'))
  }

  normalizeOptionValue(value) {
    if (!value) return '';
    return value.replace(/(\s+|\/)/g, '-').toLowerCase();
  }

  updateFirstVisibleMediaItem() {
    const mediaItems = Array.from(this.querySelectorAll('.product__media-item'));
    const firstVisibleMediaItem = mediaItems.find((mediaItem) => {
      return !mediaItem.classList.contains('product__media-item--hide') && mediaItem.style.display !== 'none';
    });

    mediaItems.forEach((mediaItem) => {
      mediaItem.classList.toggle('product__media--first-child', mediaItem === firstVisibleMediaItem);
    });
  }

  applyVariantImageFilter(colorValue, onSale = false) {
    const allThumbs = this.querySelectorAll('.product__media-item[data-media-type="image"]');
    const hasOptionDrivenMedia = this.querySelector('.product__media-item[data-option1]');
    const allThumbnailItems = this.gallery ? this.gallery.querySelectorAll('.thumbnail-list__item[data-target]') : [];
    const presentation = this.getGallerySetting('presentation', 'grid');

    if (!allThumbs.length || !hasOptionDrivenMedia) return false;

    const color = this.normalizeOptionValue(colorValue);
    const optionThumbs = color
      ? this.querySelectorAll(`.product__media-item[data-option1="${color}"]`)
      : this.querySelectorAll('.product__media-item[data-option1]');
    const thumbsToDisplay = optionThumbs.length ? optionThumbs : allThumbs;
    const selectorsToDisplay = thumbsToDisplay.length ? thumbsToDisplay.length : allThumbs.length;
    const thumbnailItemsToDisplay = allThumbnailItems.length
      ? Array.from(allThumbnailItems).filter((item) => {
        if (!optionThumbs.length) return true;
        return item.dataset.option1 === color;
      })
      : [];

    for (let thumb of allThumbs) {
      thumb.style.display = '';
      thumb.style.width = '';
      thumb.classList.add('product__media-item--hide');
      const badge = thumb.querySelector('[data-product-badge]');
      
      if (badge) badge.style.display = 'none';
      thumb.classList.remove('is-active');
    }

    for (let thumbIndex = 0, len = thumbsToDisplay.length; thumbIndex < len; thumbIndex++) {
      thumbsToDisplay[thumbIndex].classList.remove('product__media-item--hide');
      thumbsToDisplay[thumbIndex].style.display = presentation === 'carousel' ? '' : 'inline-block';
      if (thumbIndex == 0) {
        thumbsToDisplay[thumbIndex].classList.add('is-active');
        thumbsToDisplay[thumbIndex].style.width = '100%';
        const badge = thumbsToDisplay[thumbIndex].querySelector('[data-product-badge]');
        if (badge) badge.style.display = 'inline-block';
      }
    }

    this.updateFirstVisibleMediaItem();

    if (allThumbnailItems.length) {
      const visibleThumbnailItems = thumbnailItemsToDisplay.length ? thumbnailItemsToDisplay : Array.from(allThumbnailItems);

      for (let thumbnailItem of allThumbnailItems) {
        thumbnailItem.style.display = 'none';
        const button = thumbnailItem.querySelector('button');
        if (button) button.removeAttribute('aria-current');
      }

      visibleThumbnailItems.forEach((thumbnailItem, index) => {
        thumbnailItem.style.display = '';
        if (index === 0) {
          const button = thumbnailItem.querySelector('button');
          if (button) button.setAttribute('aria-current', 'true');
        }
      });
    }

    this.initPages();
    this.showFirstNSelectors(selectorsToDisplay);
    this.setActiveSelector();
    this.displaySelectors();
    this.displaySlides();
    this.slider.scrollTo({ left: 0 });
    this.applyGalleryBehavior();

    const thumbRail = this.gallery?.querySelector('[id^="GalleryThumbnails"]');
    const currentThumbButton = thumbRail?.querySelector('.thumbnail-list__item button[aria-current="true"]');
    const currentThumb = currentThumbButton?.closest('.thumbnail-list__item');
    if (currentThumb && typeof thumbRail.scrollItemIntoView === 'function') {
      requestAnimationFrame(() => {
        thumbRail.scrollItemIntoView(currentThumb, {
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      });
    }

    return true;
  }

  initVariantChangeListener() {
    document.addEventListener("colorChanged", (e) => {
      // Update selected color display if applicable
      const colorLabel = e.detail.color.toLowerCase();
      const selectedColorEl = document.getElementsByClassName('selected-color');
      if (selectedColorEl && selectedColorEl[0]) selectedColorEl[0].innerHTML = colorLabel;

      const input = document.querySelector(`input[value="${e.detail.color}"]`);
      const onSale = JSON.parse(input?.dataset.onSale || 'false');
      this.applyVariantImageFilter(e.detail.color, onSale);
    })
  }

  getGallerySetting(settingName, fallbackValue = '') {
    if (!this.gallery) return fallbackValue;
    return this.gallery.dataset[settingName] || fallbackValue;
  }

  applyGalleryBehavior() {
    const mobileBehavior = this.getGallerySetting('mobileBehavior', 'carousel');
    const isMobile = this.mediaQueryMobile.matches;
    const isMobileStacked = isMobile && mobileBehavior === 'stacked';

    this.classList.toggle('pdp-slider--mobile-stacked', isMobileStacked);

    if (this.prevButton) {
      if (isMobileStacked) {
        this.prevButton.setAttribute('hidden', 'hidden');
      } else {
        this.prevButton.removeAttribute('hidden');
      }
    }

    if (this.nextButton) {
      if (isMobileStacked) {
        this.nextButton.setAttribute('hidden', 'hidden');
      } else {
        this.nextButton.removeAttribute('hidden');
      }
    }

    if (this.slideSelectorParent) {
      if (isMobileStacked) {
        this.slideSelectorParent.setAttribute('hidden', 'hidden');
      } else {
        this.slideSelectorParent.removeAttribute('hidden');
      }
    }

    this.syncThumbnailRailHeight();
  }

  initGalleryResizeObserver() {
    if (!this.gallery || typeof ResizeObserver === 'undefined') return;

    this.galleryResizeObserver = new ResizeObserver(() => this.syncThumbnailRailHeight());
    this.galleryResizeObserver.observe(this);

    if (this.slider) {
      this.galleryResizeObserver.observe(this.slider);
    }
  }

  syncThumbnailRailHeight() {
    if (!this.gallery) return;

    const presentation = this.getGallerySetting('presentation', 'grid');
    const thumbnailPosition = this.getGallerySetting('thumbnailPosition', 'bottom');
    const isSideThumbnailLayout = presentation === 'carousel'
      && !this.mediaQueryMobile.matches
      && (thumbnailPosition === 'left' || thumbnailPosition === 'right');

    if (!isSideThumbnailLayout) {
      this.gallery.style.removeProperty('--pdp-carousel-height');
      return;
    }

    if (this.thumbnailHeightFrame) {
      cancelAnimationFrame(this.thumbnailHeightFrame);
    }

    this.thumbnailHeightFrame = requestAnimationFrame(() => {
      const activeMedia = this.slider?.querySelector('.product__media-item.is-active:not(.product__media-item--hide)');
      const visibleMedia = activeMedia || this.slider?.querySelector('.product__media-item:not(.product__media-item--hide)');
      const mediaFrame = visibleMedia?.querySelector('.product__media, .media') || visibleMedia || this.slider;
      const height = mediaFrame.getBoundingClientRect().height;

      if (height > 0) {
        this.gallery.style.setProperty('--pdp-carousel-height', `${height}px`);
      }

      const thumbnailComponent = this.gallery.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnailComponent?.updateScrollState) {
        thumbnailComponent.updateScrollState();
      }
    });
  }

  disconnectedCallback() {
    if (this.mediaQueryMobile && this.handleViewportChange) {
      this.mediaQueryMobile.removeEventListener('change', this.handleViewportChange);
    }

    if (this.handleWindowResize) {
      window.removeEventListener('resize', this.handleWindowResize);
    }

    if (this.galleryResizeObserver) {
      this.galleryResizeObserver.disconnect();
    }

    if (this.thumbnailHeightFrame) {
      cancelAnimationFrame(this.thumbnailHeightFrame);
    }
  }

  showFirstNSelectors(n) {
    if (n === 0) n = this.slideSelectors.length;

    for (let selectorIndex = 0, len = this.slideSelectors.length; selectorIndex < len; selectorIndex++) {
      const displayValue = selectorIndex < n ? 'inline-block' : 'none';
      this.slideSelectors[selectorIndex].style.display = displayValue;
    }
  }

  displaySlides() {
    this.slider.classList.add('display');
  }

  displaySelectors() {
    if (this.classList.contains('pdp-slider--mobile-stacked')) return;
    this.slideSelectorParent.classList.add('display')
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('pdp-slider-component', PDPSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.language = this.dataset.lang;
    this.skuElement = document.getElementById('product__sku-number');

    this.addEventListener('change', this.onVariantChange);
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    this.updateOptions();
    this.updateMasterId();
    this.setPriceLabelAddButton();
    this.updateMaxVariantQuantity();
    this.updateVariantMedia();
    this.addOutOfStockClass();
    this.initHelpers();

    if (window.Shopify.designMode) {
      document.addEventListener('helpers:update', this.initHelpers.bind(this));
    }
  }

  initHelpers() {
    this.fieldsets = this.querySelectorAll('fieldset');
    this.optionHelpersObj = JSON.parse(document.getElementById('optionHelpers').textContent);
     
    if (this.optionHelpersObj) {
      for (let fieldset of this.fieldsets) {
        const optionName = fieldset.dataset.optionName.toLowerCase();
        
        const optionHelpers = this.optionHelpersObj[optionName];

        if (optionHelpers) {
          const labelHelperElement = fieldset.querySelector('.form__label-helper');
          const valueHelperElement = fieldset.querySelector('.form__value-helper');
          
          if (labelHelperElement && optionHelpers.labelHelper) {
            labelHelperElement.innerHTML = optionHelpers.labelHelper;
            const scripts = labelHelperElement.getElementsByTagName('script')
            for (let i = 0; i < scripts.length; i++) {
              eval(scripts[i].innerHTML);
            }
          }
          
          if (valueHelperElement && optionHelpers.valueHelper) {
            valueHelperElement.innerHTML = optionHelpers.valueHelper;
            const scripts = valueHelperElement.getElementsByTagName('script')
            for (let i = 0; i < scripts.length; i++) {
              eval(scripts[i].innerHTML);
            }
          }
        }
      }
    }

    // this.swatchHelperObj = JSON.parse(document.getElementById('contentSwatchesPDP').textContent);
    
    // if (this.swatchHelperObj) {
    //   for (let fieldset of this.fieldsets) {
    //     const optionName = fieldset.dataset.optionName.toLowerCase();  

    //     if (optionName == 'color') {
    //       const swatchContainer = fieldset.querySelectorAll('.swatch__container-helper')
    //       const swatchInput = fieldset.querySelectorAll('input');

    //       if(swatchContainer.length > 0) {
    //         for (let i = 0; i < swatchInput.length; i ++) {
    //           const swatchHelper = this.swatchHelperObj[swatchInput[i].value.toLowerCase()]
    //           swatchContainer[i].style.background = `${swatchHelper}`         
    //         } 
    //       }                  
    //     }

    //   }
    // }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.addOutOfStockClass();
    this.emitColorData();
    this.updateSKU();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantMedia();
      this.updateURL();
      this.updateCustomizerURL();
      this.updateVariantInput();
      this.updateMaxVariantQuantity();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateCustomizerURL() {
    const jerseyCustomizerLink = document.getElementById('jerseyCustomizerLink');    

    if (jerseyCustomizerLink) {
      const customizeButton = document.getElementById('jerseyCustomizerButton');
      const jerseyMap = Array.isArray(window.jerseyProductSkuMap) ? window.jerseyProductSkuMap : [];
      const mappedVariant = jerseyMap.find((variant) => variant.id === this.currentVariant?.id);
      if (!mappedVariant) return;

      const mappedVariantSku = mappedVariant.sku;
      const isCustomizableJerseyAvailable = mappedVariant.available;
      const locale = window.Shopify.locale;
      const jerseyCustomizerLanguage = locale.toUpperCase();

      let price = document.querySelector(".price-item").innerText;

      if (isCustomizableJerseyAvailable) {
        const updatedURL = `https://fanzones.averydennison.io/Previewer/?companyName=Bauer&itemId=${mappedVariantSku}&m=true&language=${jerseyCustomizerLanguage}&source=${window.location.href}`;

        jerseyCustomizerLink.setAttribute('href', updatedURL);
        customizeButton.removeAttribute('disabled');
      } else {
        customizeButton.setAttribute('disabled', 'disabled');
      }
      
    }
  }

  emitColorData() {
    // Overridden in VariantRadios
    // TODO - support this for select dropdowns and general options if desired by later clients
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSKU() {
    if (this.skuElement && this.currentVariant) {
      this.skuElement.innerHTML = this.currentVariant.sku;
    }
  }

  findInputByValue(value) {
    return Array.from(document.querySelectorAll('input')).find(
      input => input.value.toLowerCase() === value.toLowerCase()
    );
  }

  addOutOfStockClass() {
    const variants = this.getVariantData();
    let selectedVariant = this.currentVariant;
  
    if (!selectedVariant && variants.length) {
      selectedVariant = variants[0];
    }
    if (!selectedVariant) return;
  
    function isTrulyAvailable(v) {
      if (!v.available) return false;
      if ('inventory_quantity' in v && v.inventory_quantity <= 0) return false;
      return true;
    }
  
    // Clear old strikes
    document.querySelectorAll('.strike-thru').forEach(el => el.classList.remove('strike-thru'));
  
    // ---- Collect availability
    const sizeAvailability = {};
    const colorAvailability = {};
  
    variants.forEach(variant => {
      if (variant.option1 === selectedVariant.option1 && variant.option3 === selectedVariant.option3) {
        sizeAvailability[variant.option2] ||= false;
        sizeAvailability[variant.option2] = sizeAvailability[variant.option2] || isTrulyAvailable(variant);
      }
  
      if (variant.option1 === selectedVariant.option1 && variant.option2 === selectedVariant.option2) {
        colorAvailability[variant.option3] ||= false;
        colorAvailability[variant.option3] = colorAvailability[variant.option3] || isTrulyAvailable(variant);
      }
    });
  
    // ---- Apply strikes for sizes
    Object.keys(sizeAvailability).forEach(size => {
      let input = this.findInputByValue(size);
      if (input && input.nextElementSibling && !sizeAvailability[size]) {
        input.nextElementSibling.classList.add('strike-thru');
      }
    });
  
    // ---- Apply strikes for colors
    Object.keys(colorAvailability).forEach(color => {
      let input = this.findInputByValue(color);
      if (input && input.nextElementSibling && !colorAvailability[color]) {
        input.nextElementSibling.classList.add('strike-thru');
      }
    });
  }
  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const activeMediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    const activeMedia = mediaGallery?.querySelector(`[data-media-id="${activeMediaId}"]`);
    const shouldActivateMedia = mediaGallery?.dataset.presentation !== 'grid' || activeMedia?.dataset.mediaType === 'image';

    if (mediaGallery?.setActiveMedia) {
      if (shouldActivateMedia) {
        mediaGallery.setActiveMedia(activeMediaId, true);
      }
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent?.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (modalContent && newMediaModal) {
      modalContent.prepend(newMediaModal);
    }
  }

  updateVariantMedia() {
    let color_inputs, color_dropdown, thumbs, stackedThumbs;
    
    try {
      // Query all possible color input variations
      color_inputs = document.querySelectorAll("input[name='Color'], input[name='Colour'], input[name='color'], input[name='colour']");
      color_dropdown = document.querySelectorAll("select[name='options[Color]'], select[name='options[Colour]'], select[name='options[color]'], select[name='options[colour]']");
      
      if (!color_inputs.length && !color_dropdown.length) {
        console.error('No color/colour inputs or dropdowns found on page');
      }

      // Get thumbnail elements
      thumbs = document.querySelectorAll(".thumbnail-list__item img");
      stackedThumbs = document.querySelectorAll(".product__media-item[data-media-type='image'] img");

      if (!thumbs.length && !stackedThumbs.length) {
        console.error('No thumbnail images found on page');
      }

    } catch (error) {
      console.error('Error querying color elements:', error);
    }


    if(!color_inputs.length && !color_dropdown.length) {
      const galleryViewer = document.getElementById(`GalleryViewer-${this.dataset.section}`);
      if (galleryViewer?.applyVariantImageFilter && galleryViewer.applyVariantImageFilter()) return;
    }

    if (color_inputs.length > 0 ) {
      const selectedInput = Array.from(color_inputs).find((input) => input.checked);
      const galleryViewer = document.getElementById(`GalleryViewer-${this.dataset.section}`);
      if (selectedInput && galleryViewer?.applyVariantImageFilter) {
        const usedModernFilter = galleryViewer.applyVariantImageFilter(
          selectedInput.value,
          JSON.parse(selectedInput.dataset.onSale || 'false')
        );
        if (usedModernFilter) return;
      }

      color_inputs.forEach(i => {
        //Check if swatch input or dropdown
        if (i.checked) {
          if(thumbs.length > 0) {
            thumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            })
          }

          if (stackedThumbs.length > 0 ) {
            stackedThumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              const srcParts = t.src.split("__");
              if (srcParts.length > 1) {
                const colorPart = srcParts[1].split("_")[0];
                if (colorPart && colorPart.toLowerCase() === searchValue) {
                  t.parentElement.parentElement.parentElement.style.display = "block";
                }
              }
            })
          }
        }
      })
    } else {
        const galleryViewer = document.getElementById(`GalleryViewer-${this.dataset.section}`);
        if (color_dropdown.length > 0 && galleryViewer?.applyVariantImageFilter) {
          const usedModernFilter = galleryViewer.applyVariantImageFilter(color_dropdown[0].value);
          if (usedModernFilter) return;
        }

        if (thumbs.length > 0 && color_dropdown.length > 0) {
          thumbs.forEach(t => {
          let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
            if(t.src.includes(searchValue)) {
              t.parentElement.parentElement.style.display = "block";
            } else {
              t.parentElement.parentElement.style.display = "none"
            }
          })
        }

        if (stackedThumbs.length > 0 && color_dropdown.length > 0) {
          stackedThumbs.forEach(t => {
          let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
            if(t.src.includes(searchValue)) {
              t.parentElement.parentElement.parentElement.style.display = "block";
            } else {
              t.parentElement.parentElement.parentElement.style.display = "none"
            }
          })
        }
    }
  }

  updateURL() {
    const variantUrl = this.getVariantUrl();
    if (!variantUrl) return variantUrl;
    const isQuickViewContext = Boolean(this.closest('#quickViewDrawer, .quick-view-drawer, #altContainer'));
    const shouldUpdateHistory = this.dataset.updateUrl !== 'false' && !isQuickViewContext;

    if (shouldUpdateHistory) {
      window.history.replaceState({ }, '', variantUrl);
    }

    this.dispatchEvent(new CustomEvent('variant:url:changed', {
      bubbles: true,
      detail: {
        url: variantUrl,
        variantId: this.currentVariant.id,
        updateHistory: shouldUpdateHistory
      }
    }));

    return variantUrl;
  }

  getVariantUrl() {
    if (!this.currentVariant || !this.dataset.url) return null;
    return `${this.dataset.url}?variant=${this.currentVariant.id}`;
  }

  updateShareUrl() {
    const variantUrl = this.getVariantUrl();
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !variantUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${variantUrl}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateMaxVariantQuantity () {
    const urlParams = new URLSearchParams(window.location.search);
    const firstVariant = document.querySelector('.product input[name="id"]');
    const variantID = urlParams.get('variant');
    const variantData = variantID ? this.additionalVariantData[variantID]: this.additionalVariantData[firstVariant.value] ;
    const quantityInput = document.querySelector('.product input[name="quantity"]');

    if (variantData && Number(variantData.inventory) > 0 && variantData.available == 'true' ) {
      quantityInput.setAttribute('max', variantData.inventory);
      if(Number(quantityInput.value) > Number(variantData.inventory)) {
        quantityInput.value = variantData.inventory
      }
    } else {
      quantityInput.removeAttribute('max');
    }

    if (Number(quantityInput.value) == 0) {
      quantityInput.value = 1
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available,  window.variantStrings.soldOut);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const customizeButton = document.getElementById('jerseyCustomizerButton');
    let price = document.querySelector(".price-item").innerText;

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (!addButton.hasAttribute('customerTagDisabled')){
        if (text) addButtonText.textContent = text;
      }
    } 
    else if (addButton.hasAttribute('preorder')){
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.preorder + " - " +price;
    } else {
      if (!addButton.hasAttribute('customerTagDisabled')){
        addButton.removeAttribute('disabled');
        addButton.classList.remove('visually-hidden');
        addButtonText.textContent = window.variantStrings.addToCart + " - " +price;
      }
    }

    if (customizeButton) {
      const jerseyMap = Array.isArray(window.jerseyProductSkuMap) ? window.jerseyProductSkuMap : [];
      const jerseyCustomMapped = jerseyMap.find((variant) => variant.id === this.currentVariant?.id);
      const customJerseyOptionValue = window.jerseyCustomFlags?.customJerseyOptionValue;
      if (!jerseyCustomMapped) {
        customizeButton.classList.add('visually-hidden');
        addButton.classList.remove('visually-hidden');
        if (!modifyClass) return;
        document.dispatchEvent(new CustomEvent('VariantChanged', {
          detail: {
            variant: this.currentVariant
          }
        }));
        return;
      }
      if (!customJerseyOptionValue) {
        customizeButton.classList.add('visually-hidden');
        addButton.classList.remove('visually-hidden');
        if (!modifyClass) return;
        document.dispatchEvent(new CustomEvent('VariantChanged', {
          detail: {
            variant: this.currentVariant
          }
        }));
        return;
      }

      if (jerseyCustomMapped.type === customJerseyOptionValue) {
        addButton.classList.add('visually-hidden');

        if (!this.currentVariant.available) {
          customizeButton.classList.add('visually-hidden');
        } else {
          customizeButton.textContent = window.variantStrings.addToCartCustomize + " - " + price;
          customizeButton.classList.remove('visually-hidden');
        }
      }

      if (jerseyCustomMapped.type !== customJerseyOptionValue) {
        customizeButton.classList.add('visually-hidden');
        addButton.classList.remove('visually-hidden');
      }
    }

    if (!modifyClass) return;
  
    document.dispatchEvent(new CustomEvent('VariantChanged', {
      detail: {
        variant: this.currentVariant
      }
    }));
  }

  setPriceLabelAddButton() {
    const customizeButton = document.getElementById('jerseyCustomizerButton');
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const button = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    let price = document.querySelector(".price-item").innerText;

    if (button.hasAttribute('disabled')) {
      if (!button.hasAttribute('customerTagDisabled')){
        addButtonText.textContent = window.variantStrings.soldOut; 
      }
    } else if (button.hasAttribute('preorder')){
      addButtonText.textContent = window.variantStrings.preorder + " - " + price;
    } else {
      addButtonText.textContent = window.variantStrings.addToCart + " - " + price;
    }

    if (customizeButton) {
      if (customizeButton.hasAttribute('disabled')) {
        customizeButton.textContent = window.variantStrings.soldOut;
      } else {
        customizeButton.textContent = window.variantStrings.addToCartCustomize + " - " + price;
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.emitColorData();
  }

  emitColorData() {
    const colorInputs = Array.from(this.querySelectorAll("input[name='Color']"));

    if (colorInputs.length) {
      const selectedInput = colorInputs.find(input => input.checked)
      if (selectedInput) {
        document.dispatchEvent(new CustomEvent('colorChanged',{
          detail: {
            color: selectedInput.value
          }
        }))
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

const quantityInput = document.querySelector('.product input[name="quantity"]');
if (quantityInput) {
  quantityInput.addEventListener('change', function() {
    let qtyMax = quantityInput.getAttribute("max");
    if (qtyMax != null && Number(quantityInput.value) > Number(qtyMax)) {
      quantityInput.value = qtyMax;
    }
  })
}

function calculateHeaderHeight() {
	const announcementBar = document.getElementById('shopify-section-announcement-bar');
	const header = document.getElementById('shopify-section-header');

  let totalHeaderHeight = 0;

  if (header?.classList.contains("shopify-section-header-sticky")) {
    totalHeaderHeight = header.offsetHeight;
  } else if (announcementBar && header) {
    totalHeaderHeight = announcementBar.offsetHeight + header.offsetHeight;
  }

	document.documentElement.style.setProperty('--calculated-header-height', totalHeaderHeight + 'px');
}

function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

window.addEventListener("resize", throttle(calculateHeaderHeight, 250));
window.addEventListener("scroll", throttle(calculateHeaderHeight, 250));
window.addEventListener('DOMContentLoaded', calculateHeaderHeight);

/*Mybauer gtm triggers*/
(function customanalytics() {
  const selector = '[data-attr-track="true"]';
  document.querySelector('.my-bauer') && document.querySelector('.my-bauer').addEventListener("click", function (event) {
    const closestTrigger = event.target.closest(selector);
    var myBauerProduct = 'playerSticks';

    if(closestTrigger !== null && closestTrigger.hasAttribute("data-attr-analytics-trigger") && closestTrigger.hasAttribute("data-attr-analytics-value")) {
      const analyticsDataTrigger = closestTrigger.getAttribute("data-attr-analytics-trigger");
      const analyticsDataValue = closestTrigger.getAttribute("data-attr-analytics-value");
      const triggerURL = $(this).attr("data-product-form-data-url");
      if(triggerURL.includes('goalie')) {
        myBauerProduct = 'goalieSticks';
      }else if(triggerURL.includes('quickTurn')) {
        myBauerProduct = 'quickTurnSticks';
      }else if(triggerURL.includes('skate')) {
        myBauerProduct = 'playerSkates';
      }else if(triggerURL.includes('Steel')) {
        myBauerProduct = 'playerSteels';
      }

      if(analyticsDataTrigger === 'product_selection') {
        document.dispatchEvent(new CustomEvent('MyBauerStarted', {
          detail: {
            myBauerProduct: myBauerProduct,
            myBauerModel: analyticsDataValue,
            country: window.Shopify.country
          }
        }));
      }

      if(closestTrigger.hasAttribute("data-attr-analytics-email")) {
        const email = closestTrigger.getAttribute("data-attr-analytics-email");
        document.dispatchEvent(new CustomEvent('MyBauerCustomized', {
          detail: {
            myBauerProduct: myBauerProduct,
            product: analyticsDataValue,
            country: window.Shopify.country,
            email: email,
            clickText: 'Share'
          }
        }));
      }
    }
  });
})();

function handleAnchorScrollTo(e) {
  if (e.target.getAttribute('href').indexOf('#') === -1) return;
  e.preventDefault();
  const target = document.querySelector(`${e.target.getAttribute('href')}`);
  handleScrollTo(target);
  window.location.hash = e.target.getAttribute('href');
}
function handleScrollTo(target) {
  if (target) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: target.offsetTop - 40,
    });
  }
}

const urlParams = new URLSearchParams(window.location.search);

// if user app is consent hide cookies
const app_consent = urlParams.get('app_consent');

if(app_consent != "true") {
  var cookieInterval = setInterval(() => {
    if($('#shopify-pc__banner').length) {
      $('#shopify-pc__banner').attr('style', 'display: block !important;');;
      clearInterval(cookieInterval);
    }
  }, 1000);
}

// close drawer modals when clicking outside
const drawerModalOverlays = document.querySelectorAll('#DrawerModal-Overlay');

Array.from(drawerModalOverlays).forEach(overlay => {
  overlay.addEventListener('click', function(event) {
    const modal = overlay.parentElement;

    if (modal) {
      modal.classList.remove('active');
      document.body.classList.remove('overflow-hidden')
    }
  });
});

function refreshYotpoWidgets() {
  const tryInit = () => {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
      return true;
    }
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
      return true;
    }
    if (window.yotpo && window.Yotpo?.API) {
      try {
        const api = new window.Yotpo.API(window.yotpo);
        api.refreshWidgets();
        return true;
      } catch (_error) {
        return false;
      }
    }
    return false;
  };

  if (tryInit()) return;

  let attempts = 0;
  const intervalId = setInterval(() => {
    if (tryInit() || ++attempts >= 10) {
      clearInterval(intervalId);
    }
  }, 200);
}

document.addEventListener('product:loaded', () => {
  requestAnimationFrame(() => refreshYotpoWidgets());
});

// Function to handle click on product sibling variant links
document.addEventListener('click', function(event) {
  const link = event.target.closest('.product__sibling-variant-link');
  if (link) {
    const isQuickViewContext = Boolean(link.closest('#quickViewDrawer, .quick-view-drawer, #altContainer'));
    if (isQuickViewContext) return;
    event.preventDefault();
    if (link.dataset.loading === 'true') return;
    const productUrl = link.getAttribute('href');
    if (!productUrl) return;
    
    const productContainer = document.querySelector('.product');
    const siblingVariantContainer = link.closest('.product__sibling-variant-container');
    const subWrapper = link.closest('.product__sub-wrapper') || document.querySelector('.product__sub-wrapper');
    showSpinnerFormProduct({ trigger: link, siblingVariantContainer, subWrapper });
    fetch(productUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        
        const newProductSection = newDocument.querySelector('.product');
        
        if (newProductSection && productContainer) {
          productContainer.innerHTML = newProductSection.innerHTML;
          
          window.history.replaceState({}, '', productUrl);
          const scripts = newProductSection.querySelectorAll('script');
          scripts.forEach(script => {
            if (script.textContent) {
              try {
                eval(script.textContent);
              } catch (e) {
                console.error('Error executing script:', e);
              }
            }
          });
          
          calculateHeaderHeight();

          // Re-run Klaviyo's back-in-stock trigger for the newly swapped-in product.
          // enableKlaviyoBackInStock is defined per-site in theme.liquid (only present when
          // Klaviyo back-in-stock is enabled for this product), so guard for its existence.
          if (typeof enableKlaviyoBackInStock === 'function') {
            enableKlaviyoBackInStock();
          }

          document.dispatchEvent(new CustomEvent('product:loaded', {
            detail: { url: productUrl }
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching product:', error);
      })
      .finally(() => {
        hideSpinnerFormProduct({ trigger: link, siblingVariantContainer, subWrapper });
      });
  }
});

function setSiblingVariantLinksDisabled(container, disabled) {
  if (!container) return;
  container.querySelectorAll('.product__sibling-variant-link').forEach((a) => {
    if (disabled) {
      a.classList.add('is-disabled');
      a.setAttribute('aria-disabled', 'true');
    } else {
      a.classList.remove('is-disabled');
      a.removeAttribute('aria-disabled');
      a.removeAttribute('data-loading');
    }
  });
}

function showSpinnerFormProduct({ trigger, siblingVariantContainer, subWrapper } = {}) {
  // Progress bar on `.product__sub-wrapper`
  if (subWrapper) {
    subWrapper.classList.add('is-loading');
    subWrapper.setAttribute('aria-busy', 'true');
  }

  // Prevent rapid re-clicks while loading
  if (trigger) trigger.dataset.loading = 'true';
  if (siblingVariantContainer) setSiblingVariantLinksDisabled(siblingVariantContainer, true);
}

function hideSpinnerFormProduct({ trigger, siblingVariantContainer, subWrapper } = {}) {
  // If the product content got replaced, `subWrapper` might no longer be connected.
  const wrapperToClear = (subWrapper && subWrapper.isConnected)
    ? subWrapper
    : document.querySelector('.product__sub-wrapper.is-loading');

  if (wrapperToClear) {
    wrapperToClear.classList.remove('is-loading');
    wrapperToClear.removeAttribute('aria-busy');
  }

  if (trigger && trigger.isConnected) trigger.removeAttribute('data-loading');
  if (siblingVariantContainer && siblingVariantContainer.isConnected) setSiblingVariantLinksDisabled(siblingVariantContainer, false);
}
